import React from "react";

/** Header wordmark — şeffaf, PNG siyah zemini yok (SVG + metin). */
export default function HeaderBrand() {
  return (
    <span className="inline-flex items-center gap-3 md:gap-4 text-left bg-transparent">
      <span className="h-12 w-12 md:h-14 md:w-14 shrink-0" aria-hidden>
        <svg
          className="h-full w-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 3L42 13.5V34.5L24 45L6 34.5V13.5L24 3Z"
            fill="#2563eb"
            stroke="#1d4ed8"
            strokeWidth="1.5"
          />
          <text
            x="24"
            y="32"
            textAnchor="middle"
            fill="white"
            fontFamily="system-ui, -apple-system, sans-serif"
            fontSize="16"
            fontWeight="800"
            letterSpacing="-0.02em"
          >
            CB
          </text>
        </svg>
      </span>
      <span className="leading-tight min-w-0">
        <span className="font-display font-extrabold text-lg md:text-xl tracking-tight block">
          <span className="text-slate-900">Commodity</span>
          <span className="text-red-600">Bid</span>
        </span>
        <span className="block text-xs md:text-sm font-medium text-slate-500 tracking-wide mt-0.5 md:mt-1">
          Find The Best Price
        </span>
      </span>
    </span>
  );
}
